<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('drawSetting.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('drawSetting.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">
            {{ $t('add_new') }}
          </ts-button>
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('drawSetting.search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.game_setting.game_setting }}</td>
            <td>{{ record.game_prefix.prefix_sample }}</td>
            <td>{{ record.draw_time }}</td>
            <td>{{ record.jackpot }}</td>
            <td class="text-center">
              <i class="fas fa-check ts-text-blue-600" v-if="record.monday"></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i
                class="fas fa-check ts-text-blue-600"
                v-if="record.tuesday"
              ></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i
                class="fas fa-check ts-text-blue-600"
                v-if="record.wednesday"
              ></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i
                class="fas fa-check ts-text-blue-600"
                v-if="record.thursday"
              ></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i class="fas fa-check ts-text-blue-600" v-if="record.friday"></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i
                class="fas fa-check ts-text-blue-600"
                v-if="record.saturday"
              ></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <i class="fas fa-check ts-text-blue-600" v-if="record.sunday"></i>
              <i class="fas fa-times ts-text-red-600" v-else></i>
            </td>
            <td class="text-center">
              <span class="badge badge-success" v-if="record.is_active"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td class="text-center">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin ml-2"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash ml-2 text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- form create or update -->
    <a-modal
      :title="isEdit ? $t('update') : $t('create')"
      v-if="show_form"
      v-model="show_form"
      width="400px"
      :footer="null"
      :maskClosable="false"
      @cancel="cancel"
      :zIndex="1020"
    >
      <form-component @close="cancel" />
    </a-modal>
  </div>
</template>

<script>
import FormComponent from './form'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'drawSetting',
  components: {
    FormComponent,
  },
  data() {
    return {
      loading: false,
      show_form: false,
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administrator/drawSetting', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administrator.drawSetting.search
      },
      set(newValue) {
        this.$store.commit('administrator/drawSetting/SET_SEARCH', newValue)
        this.$store.commit('administrator/drawSetting/RESET_CURRENT_PAGE')
      },
    },
    columns() {
      return [
        { name: this.$t('drawSetting.gameSetting') },
        { name: this.$t('drawSetting.prefix') },
        { name: this.$t('drawSetting.drawTime') },
        { name: this.$t('drawSetting.jackpot') },
        { name: this.$t('drawSetting.monday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.tuesday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.wednesday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.thursday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.friday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.saturday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.sunday'), style: 'text-align:center' },
        { name: this.$t('drawSetting.isActive'), style: 'text-align:center' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' },
      ]
    },
    isEdit() {
      return !_.isEmpty(this.$store.state.administrator.drawSetting.edit_data)
    },
  },
  methods: {
    addNew() {
      this.show_form = true
    },
    cancel() {
      this.show_form = false
      this.fetchData()
      this.$store.commit('administrator/drawSetting/SET_EDIT_DATA', {})
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('administrator/drawSetting/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.$store.commit('administrator/drawSetting/SET_EDIT_DATA', record)
      this.show_form = true
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch(
          'administrator/drawSetting/destroy',
          record.game_draw_setting_id
        )
        .then((response) => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('administrator/drawSetting/RESET_STATE')
    next()
  },
}
</script>